import { useReducer } from 'react';

import { IAction } from 'src/utils/ts-utilities';

import { type IDateRange, type IFilterKey } from '../model';

enum ActionEnum {
  SET_EVENT_TYPE = 'set-event-type',
  SET_DATE_RANGE = 'set-date-range',
  SET_PAGE = 'set-page',
}

type IActionReducer =
  | IAction<ActionEnum.SET_EVENT_TYPE, { eventType: IFilterKey | null }>
  | IAction<ActionEnum.SET_DATE_RANGE, { dateRange: IDateRange | null }>
  | IAction<ActionEnum.SET_PAGE, { page: number }>;

export type IState = {
  page: number;
  eventType: IFilterKey | null;
  dateRange: IDateRange | null;
};

const initialState: IState = {
  page: 1,
  eventType: null,
  dateRange: null,
};

const reducer = (state: IState, action: IActionReducer): IState => {
  switch (action.type) {
    case ActionEnum.SET_EVENT_TYPE:
      return { ...state, eventType: action.payload.eventType, page: 1 };
    case ActionEnum.SET_DATE_RANGE:
      return { ...state, dateRange: action.payload.dateRange, page: 1 };
    case ActionEnum.SET_PAGE:
      return { ...state, page: action.payload.page };
    default:
      return state;
  }
};

export const useAuditLogsSlice = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const setEventType = (eventType: IFilterKey | null) =>
    dispatch({ type: ActionEnum.SET_EVENT_TYPE, payload: { eventType } });

  const setDateRange = (dateRange: IDateRange | null) =>
    dispatch({ type: ActionEnum.SET_DATE_RANGE, payload: { dateRange } });

  const setPage = (page: number) => dispatch({ type: ActionEnum.SET_PAGE, payload: { page } });

  return { ...state, setEventType, setDateRange, setPage };
};
